export const sizeUtilsMixins = {
  methods: {
    getSizeName(name) {
      return name === 'default' ? this.$t('message.common.default') : name
    },
  },
}
